import React from 'react';

import { BaseIconProps } from './';

export const Close = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(10.8,0,0,10.8,318.4473,316.7815)"
    d="m 11.423987,20.66838 -40.909848,-40.909849 9.106815,-9.081819 40.901517,40.909848 40.893187,-40.909848 9.08182,9.081819 -40.884855,40.909849 40.901516,40.909848 -9.09848,9.08182 -40.909851,-40.909848 -40.884853,40.909848 -9.090151,-9.08182 z"
    fill={fill}
  />
);
